import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getDashboardMenuCount, emptyDashboardMenuCount } from "../../actions/dashboardActions/customers.actions";
import { getUsersActiveTab } from "../../actions/user.actions";
import { getDashboardData, getUser, getAuthData, createLoadingSelector, getUserPermission } from "../../selectors";
import Tiles from "./Tiles";
import Content from "./Content";
import isEmpty from "../../utils/helpers";
import {showModal} from "src/actions/modal.actions";
import {getAppInfo} from "src/actions/sideBar.actions";
import {getPublicSystemConfig} from "src/actions/systemConfig.actions";

class Dashboard extends Component {
  state = {
    activeTile: "",
  };

  componentDidMount() {
    const { user, dashboardMenuCount, getDashboardMenuCount, changeNavBarType, getPublicSystemConfig,
      getUsersActiveTab, showModal, enabledTiles, getAppInfo, releaseNotesConfig, releaseNotesDisabled} = this.props

    // Change navbar type and color
    document.title = "Home - camvio.cloud";
    changeNavBarType("default", "Home");

    // Load dashboard item counts
    if (isEmpty(dashboardMenuCount)) {
      getDashboardMenuCount();
    }

    let activeTab;

    if (!sessionStorage.getItem("activeTab")) {
      activeTab = "customers";
    } else {
      activeTab = sessionStorage.getItem("activeTab");
      window.location.hash = activeTab;
      getUsersActiveTab({ activeTab: activeTab });
      sessionStorage.removeItem("activeTab");
    }
    if (!enabledTiles.includes(activeTab)) activeTab = enabledTiles[0];

    this.setState({ activeTile: activeTab });


    /** First we check if user has release notes disabled configuration set to false
     *  if user hasn't seen release notes before or user has set a reminder
     * AND they haven't seen them since logging in then we automatically show release notes **/
      if(this.ReleaseNotesConfigValue(releaseNotesDisabled)) {
        if(JSON.parse(localStorage.getItem("ReleaseNotesViewedSinceLogin")) === false ||
            (JSON.parse(localStorage.getItem("ReleaseNotesReminderSet")) === true &&
                JSON.parse(localStorage.getItem("ReleaseNotesViewedSinceLogin")) === false)
        ) {
          getAppInfo().then((resp) => {
            let modifiedVersionNumber = this.trimVersion(resp.apiVersion)
            showModal('RELEASE_NOTES_MODAL', {releaseVersion: modifiedVersionNumber})
          });
        }
      }
  }



  componentWillUnmount() {
    clearInterval(this.interval);
  }

  trimVersion = (versionNumber) => {
    /**We trim the version number to include only major+minor versions to send in a GET request for Wordpress Release Notes **/
    let versionArray = versionNumber.split(".")
    let modifiedVersionNumber = versionArray.slice(0, versionArray.length - 1).join(".")
    return modifiedVersionNumber
  }

  ReleaseNotesConfigValue = (releaseNotesDisabled) => {
    if(releaseNotesDisabled) {
      let boolValue = true;

      if (releaseNotesDisabled.toLowerCase() === "false") {
        boolValue = false;
      }
      return !boolValue
    } else {
      //If no release notes config set, then we return false to not show release notes
      return false
    }
  }


  handleTileChange = (tile) => {
    this.setState({
      activeTile: tile,
    });
    this.props.getUsersActiveTab({ activeTab: tile });
    window.location.hash = tile;
  };

  render() {
    const { activeTile } = this.state;
    const { dashboardMenuCount, dashboardMenuCountLoading, enabledTiles } = this.props;

      return (
      <div className="cmv-dashboard-modern">
        <div className="cmv-container cmv-container-dashboard cmv-container-dashboard-tiles">

          <Tiles
            enabledTiles={enabledTiles}
            activeTile={activeTile}
            handleTileChange={this.handleTileChange}
            dashboardMenuCount={dashboardMenuCount}
            dashboardMenuCountLoading={dashboardMenuCountLoading}
          />
          <Content
            activeTile={activeTile}
            dashboardMenuCount={dashboardMenuCount}
            enabledTiles={enabledTiles}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  customersServedCount: PropTypes.number,
  getCustomersServedCount: PropTypes.func,
};

const dashboardMenuCountLoadingSelector = createLoadingSelector(["SET_DASHBOARD_MENU_COUNT"]);

const mapStateToProps = (state) => {
  const dashboardMenuCount = getDashboardData(state).dashboardMenuCount,
    dashboardMenuCountLoading = dashboardMenuCountLoadingSelector(state),
    user = getUser(state).user,
    username = getAuthData(state).username,
    tilePermissionMyDay = getUserPermission(state, "WEB_MENU", "SHOW_MENU_DASH_MYDAY"),
    tilePermissionCustomers = getUserPermission(state, "WEB_MENU", "SHOW_MENU_DASH_CUSTOMERS"),
    tilePermissionTasks = getUserPermission(state, "WEB_MENU", "SHOW_MENU_DASH_TASKS"),
    tilePermissionOrders = getUserPermission(state, "WEB_MENU", "SHOW_MENU_DASH_ORDERS"),
    tilePermissionTickets = getUserPermission(state, "WEB_MENU", "SHOW_MENU_DASH_TICKETS"),
    tilePermissionAppointments = getUserPermission(state, "WEB_MENU", "SHOW_MENU_DASH_APPOINTMENTS");
    const releaseNotes = state.domain.releaseNotes;
    const releaseNotesDisabled = state.user?.configuration.find((x) => x.key === "releaseNotes.disabled")?.value



  const enabledTiles = [
    tilePermissionMyDay ? "myday" : null,
    tilePermissionCustomers ? "customers" : null,
    tilePermissionTasks ? "tasks" : null,
    tilePermissionOrders ? "orders" : null,
    tilePermissionTickets ? "tickets" : null,
    tilePermissionAppointments ? "appointments" : null,
  ].filter((tile) => tile !== null);


  const activeTab = state.user.activeTab;
  return {
    dashboardMenuCount,
    dashboardMenuCountLoading,
    user,
    username,
    activeTab,
    enabledTiles,
    releaseNotes,
    releaseNotesDisabled
  };
};

const mapDispatchToProps = {
  getDashboardMenuCount,
  emptyDashboardMenuCount,
  getUsersActiveTab,
  showModal,
  getAppInfo,
  getPublicSystemConfig
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
